// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: structs/structs/genesis.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { AddressNonceRecord, AddressRecord } from "./address";
import { Agreement } from "./agreement";
import { Allocation } from "./allocation";
import { Fleet } from "./fleet";
import { GridRecord } from "./grid";
import { Guild, GuildMembershipApplication } from "./guild";
import { Infusion } from "./infusion";
import { Params } from "./params";
import { GuildRankPermissionRecord, PermissionRecord } from "./permission";
import { Planet, PlanetAttributeRecord } from "./planet";
import { Player } from "./player";
import { Provider, ProviderGuildAccessRecord } from "./provider";
import { Reactor } from "./reactor";
import { Struct, StructAttributeRecord, StructDefender, StructDestructionQueueRecord } from "./struct";
import { Substation } from "./substation";

export const protobufPackage = "structs.structs";

export interface GenesisState {
  params: Params | undefined;
  portId: string;
  vaultOwnerList: string[];
  allocationList: Allocation[];
  allocationCount: string;
  agreementList: Agreement[];
  infusionList: Infusion[];
  infusionDestructionQueue: string[];
  infusionMaturitySweepQueue: string[];
  guildList: Guild[];
  guildCount: string;
  guildMembershipApplicationList: GuildMembershipApplication[];
  guildCharterAnchor: string;
  planetList: Planet[];
  planetCount: string;
  planetAttributeList: PlanetAttributeRecord[];
  playerList: Player[];
  playerCount: string;
  providerList: Provider[];
  providerCount: string;
  providerGuildAccessList: ProviderGuildAccessRecord[];
  reactorList: Reactor[];
  reactorCount: string;
  structList: Struct[];
  structCount: string;
  structAttributeList: StructAttributeRecord[];
  structDefenderList: StructDefender[];
  structDestructionQueue: StructDestructionQueueRecord[];
  substationList: Substation[];
  substationCount: string;
  permissionList: PermissionRecord[];
  guildRankPermissionList: GuildRankPermissionRecord[];
  permissionCleanupQueue: string[];
  generatorPowerQueue: string[];
  stakingUnbondingId: string;
  reactorStakeCapActive: boolean;
  gridList: GridRecord[];
  gridCascadeQueue: string[];
  addressList: AddressRecord[];
  addressNonceList: AddressNonceRecord[];
  fleetList: Fleet[];
}

function createBaseGenesisState(): GenesisState {
  return {
    params: undefined,
    portId: "",
    vaultOwnerList: [],
    allocationList: [],
    allocationCount: "0",
    agreementList: [],
    infusionList: [],
    infusionDestructionQueue: [],
    infusionMaturitySweepQueue: [],
    guildList: [],
    guildCount: "0",
    guildMembershipApplicationList: [],
    guildCharterAnchor: "0",
    planetList: [],
    planetCount: "0",
    planetAttributeList: [],
    playerList: [],
    playerCount: "0",
    providerList: [],
    providerCount: "0",
    providerGuildAccessList: [],
    reactorList: [],
    reactorCount: "0",
    structList: [],
    structCount: "0",
    structAttributeList: [],
    structDefenderList: [],
    structDestructionQueue: [],
    substationList: [],
    substationCount: "0",
    permissionList: [],
    guildRankPermissionList: [],
    permissionCleanupQueue: [],
    generatorPowerQueue: [],
    stakingUnbondingId: "0",
    reactorStakeCapActive: false,
    gridList: [],
    gridCascadeQueue: [],
    addressList: [],
    addressNonceList: [],
    fleetList: [],
  };
}

export const GenesisState: MessageFns<GenesisState> = {
  encode(message: GenesisState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.params !== undefined) {
      Params.encode(message.params, writer.uint32(10).fork()).join();
    }
    if (message.portId !== "") {
      writer.uint32(18).string(message.portId);
    }
    for (const v of message.vaultOwnerList) {
      writer.uint32(306).string(v!);
    }
    for (const v of message.allocationList) {
      Allocation.encode(v!, writer.uint32(26).fork()).join();
    }
    if (message.allocationCount !== "0") {
      writer.uint32(224).uint64(message.allocationCount);
    }
    for (const v of message.agreementList) {
      Agreement.encode(v!, writer.uint32(34).fork()).join();
    }
    for (const v of message.infusionList) {
      Infusion.encode(v!, writer.uint32(42).fork()).join();
    }
    for (const v of message.infusionDestructionQueue) {
      writer.uint32(234).string(v!);
    }
    for (const v of message.infusionMaturitySweepQueue) {
      writer.uint32(282).string(v!);
    }
    for (const v of message.guildList) {
      Guild.encode(v!, writer.uint32(50).fork()).join();
    }
    if (message.guildCount !== "0") {
      writer.uint32(56).uint64(message.guildCount);
    }
    for (const v of message.guildMembershipApplicationList) {
      GuildMembershipApplication.encode(v!, writer.uint32(266).fork()).join();
    }
    if (message.guildCharterAnchor !== "0") {
      writer.uint32(288).uint64(message.guildCharterAnchor);
    }
    for (const v of message.planetList) {
      Planet.encode(v!, writer.uint32(66).fork()).join();
    }
    if (message.planetCount !== "0") {
      writer.uint32(72).uint64(message.planetCount);
    }
    for (const v of message.planetAttributeList) {
      PlanetAttributeRecord.encode(v!, writer.uint32(194).fork()).join();
    }
    for (const v of message.playerList) {
      Player.encode(v!, writer.uint32(82).fork()).join();
    }
    if (message.playerCount !== "0") {
      writer.uint32(88).uint64(message.playerCount);
    }
    for (const v of message.providerList) {
      Provider.encode(v!, writer.uint32(98).fork()).join();
    }
    if (message.providerCount !== "0") {
      writer.uint32(104).uint64(message.providerCount);
    }
    for (const v of message.providerGuildAccessList) {
      ProviderGuildAccessRecord.encode(v!, writer.uint32(218).fork()).join();
    }
    for (const v of message.reactorList) {
      Reactor.encode(v!, writer.uint32(114).fork()).join();
    }
    if (message.reactorCount !== "0") {
      writer.uint32(120).uint64(message.reactorCount);
    }
    for (const v of message.structList) {
      Struct.encode(v!, writer.uint32(130).fork()).join();
    }
    if (message.structCount !== "0") {
      writer.uint32(136).uint64(message.structCount);
    }
    for (const v of message.structAttributeList) {
      StructAttributeRecord.encode(v!, writer.uint32(202).fork()).join();
    }
    for (const v of message.structDefenderList) {
      StructDefender.encode(v!, writer.uint32(210).fork()).join();
    }
    for (const v of message.structDestructionQueue) {
      StructDestructionQueueRecord.encode(v!, writer.uint32(250).fork()).join();
    }
    for (const v of message.substationList) {
      Substation.encode(v!, writer.uint32(146).fork()).join();
    }
    if (message.substationCount !== "0") {
      writer.uint32(152).uint64(message.substationCount);
    }
    for (const v of message.permissionList) {
      PermissionRecord.encode(v!, writer.uint32(162).fork()).join();
    }
    for (const v of message.guildRankPermissionList) {
      GuildRankPermissionRecord.encode(v!, writer.uint32(274).fork()).join();
    }
    for (const v of message.permissionCleanupQueue) {
      writer.uint32(330).string(v!);
    }
    for (const v of message.generatorPowerQueue) {
      writer.uint32(338).string(v!);
    }
    if (message.stakingUnbondingId !== "0") {
      writer.uint32(360).uint64(message.stakingUnbondingId);
    }
    if (message.reactorStakeCapActive !== false) {
      writer.uint32(368).bool(message.reactorStakeCapActive);
    }
    for (const v of message.gridList) {
      GridRecord.encode(v!, writer.uint32(170).fork()).join();
    }
    for (const v of message.gridCascadeQueue) {
      writer.uint32(242).string(v!);
    }
    for (const v of message.addressList) {
      AddressRecord.encode(v!, writer.uint32(178).fork()).join();
    }
    for (const v of message.addressNonceList) {
      AddressNonceRecord.encode(v!, writer.uint32(298).fork()).join();
    }
    for (const v of message.fleetList) {
      Fleet.encode(v!, writer.uint32(186).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GenesisState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGenesisState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.params = Params.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.portId = reader.string();
          continue;
        }
        case 38: {
          if (tag !== 306) {
            break;
          }

          message.vaultOwnerList.push(reader.string());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.allocationList.push(Allocation.decode(reader, reader.uint32()));
          continue;
        }
        case 28: {
          if (tag !== 224) {
            break;
          }

          message.allocationCount = reader.uint64().toString();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.agreementList.push(Agreement.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.infusionList.push(Infusion.decode(reader, reader.uint32()));
          continue;
        }
        case 29: {
          if (tag !== 234) {
            break;
          }

          message.infusionDestructionQueue.push(reader.string());
          continue;
        }
        case 35: {
          if (tag !== 282) {
            break;
          }

          message.infusionMaturitySweepQueue.push(reader.string());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.guildList.push(Guild.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.guildCount = reader.uint64().toString();
          continue;
        }
        case 33: {
          if (tag !== 266) {
            break;
          }

          message.guildMembershipApplicationList.push(GuildMembershipApplication.decode(reader, reader.uint32()));
          continue;
        }
        case 36: {
          if (tag !== 288) {
            break;
          }

          message.guildCharterAnchor = reader.uint64().toString();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.planetList.push(Planet.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.planetCount = reader.uint64().toString();
          continue;
        }
        case 24: {
          if (tag !== 194) {
            break;
          }

          message.planetAttributeList.push(PlanetAttributeRecord.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.playerList.push(Player.decode(reader, reader.uint32()));
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.playerCount = reader.uint64().toString();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.providerList.push(Provider.decode(reader, reader.uint32()));
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.providerCount = reader.uint64().toString();
          continue;
        }
        case 27: {
          if (tag !== 218) {
            break;
          }

          message.providerGuildAccessList.push(ProviderGuildAccessRecord.decode(reader, reader.uint32()));
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.reactorList.push(Reactor.decode(reader, reader.uint32()));
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.reactorCount = reader.uint64().toString();
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.structList.push(Struct.decode(reader, reader.uint32()));
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.structCount = reader.uint64().toString();
          continue;
        }
        case 25: {
          if (tag !== 202) {
            break;
          }

          message.structAttributeList.push(StructAttributeRecord.decode(reader, reader.uint32()));
          continue;
        }
        case 26: {
          if (tag !== 210) {
            break;
          }

          message.structDefenderList.push(StructDefender.decode(reader, reader.uint32()));
          continue;
        }
        case 31: {
          if (tag !== 250) {
            break;
          }

          message.structDestructionQueue.push(StructDestructionQueueRecord.decode(reader, reader.uint32()));
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.substationList.push(Substation.decode(reader, reader.uint32()));
          continue;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.substationCount = reader.uint64().toString();
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.permissionList.push(PermissionRecord.decode(reader, reader.uint32()));
          continue;
        }
        case 34: {
          if (tag !== 274) {
            break;
          }

          message.guildRankPermissionList.push(GuildRankPermissionRecord.decode(reader, reader.uint32()));
          continue;
        }
        case 41: {
          if (tag !== 330) {
            break;
          }

          message.permissionCleanupQueue.push(reader.string());
          continue;
        }
        case 42: {
          if (tag !== 338) {
            break;
          }

          message.generatorPowerQueue.push(reader.string());
          continue;
        }
        case 45: {
          if (tag !== 360) {
            break;
          }

          message.stakingUnbondingId = reader.uint64().toString();
          continue;
        }
        case 46: {
          if (tag !== 368) {
            break;
          }

          message.reactorStakeCapActive = reader.bool();
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.gridList.push(GridRecord.decode(reader, reader.uint32()));
          continue;
        }
        case 30: {
          if (tag !== 242) {
            break;
          }

          message.gridCascadeQueue.push(reader.string());
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.addressList.push(AddressRecord.decode(reader, reader.uint32()));
          continue;
        }
        case 37: {
          if (tag !== 298) {
            break;
          }

          message.addressNonceList.push(AddressNonceRecord.decode(reader, reader.uint32()));
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.fleetList.push(Fleet.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GenesisState {
    return {
      params: isSet(object.params) ? Params.fromJSON(object.params) : undefined,
      portId: isSet(object.portId) ? globalThis.String(object.portId) : "",
      vaultOwnerList: globalThis.Array.isArray(object?.vaultOwnerList)
        ? object.vaultOwnerList.map((e: any) => globalThis.String(e))
        : [],
      allocationList: globalThis.Array.isArray(object?.allocationList)
        ? object.allocationList.map((e: any) => Allocation.fromJSON(e))
        : [],
      allocationCount: isSet(object.allocationCount) ? globalThis.String(object.allocationCount) : "0",
      agreementList: globalThis.Array.isArray(object?.agreementList)
        ? object.agreementList.map((e: any) => Agreement.fromJSON(e))
        : [],
      infusionList: globalThis.Array.isArray(object?.infusionList)
        ? object.infusionList.map((e: any) => Infusion.fromJSON(e))
        : [],
      infusionDestructionQueue: globalThis.Array.isArray(object?.infusionDestructionQueue)
        ? object.infusionDestructionQueue.map((e: any) => globalThis.String(e))
        : [],
      infusionMaturitySweepQueue: globalThis.Array.isArray(object?.infusionMaturitySweepQueue)
        ? object.infusionMaturitySweepQueue.map((e: any) => globalThis.String(e))
        : [],
      guildList: globalThis.Array.isArray(object?.guildList)
        ? object.guildList.map((e: any) => Guild.fromJSON(e))
        : [],
      guildCount: isSet(object.guildCount) ? globalThis.String(object.guildCount) : "0",
      guildMembershipApplicationList: globalThis.Array.isArray(object?.guildMembershipApplicationList)
        ? object.guildMembershipApplicationList.map((e: any) => GuildMembershipApplication.fromJSON(e))
        : [],
      guildCharterAnchor: isSet(object.guildCharterAnchor) ? globalThis.String(object.guildCharterAnchor) : "0",
      planetList: globalThis.Array.isArray(object?.planetList)
        ? object.planetList.map((e: any) => Planet.fromJSON(e))
        : [],
      planetCount: isSet(object.planetCount) ? globalThis.String(object.planetCount) : "0",
      planetAttributeList: globalThis.Array.isArray(object?.planetAttributeList)
        ? object.planetAttributeList.map((e: any) => PlanetAttributeRecord.fromJSON(e))
        : [],
      playerList: globalThis.Array.isArray(object?.playerList)
        ? object.playerList.map((e: any) => Player.fromJSON(e))
        : [],
      playerCount: isSet(object.playerCount) ? globalThis.String(object.playerCount) : "0",
      providerList: globalThis.Array.isArray(object?.providerList)
        ? object.providerList.map((e: any) => Provider.fromJSON(e))
        : [],
      providerCount: isSet(object.providerCount) ? globalThis.String(object.providerCount) : "0",
      providerGuildAccessList: globalThis.Array.isArray(object?.providerGuildAccessList)
        ? object.providerGuildAccessList.map((e: any) => ProviderGuildAccessRecord.fromJSON(e))
        : [],
      reactorList: globalThis.Array.isArray(object?.reactorList)
        ? object.reactorList.map((e: any) => Reactor.fromJSON(e))
        : [],
      reactorCount: isSet(object.reactorCount) ? globalThis.String(object.reactorCount) : "0",
      structList: globalThis.Array.isArray(object?.structList)
        ? object.structList.map((e: any) => Struct.fromJSON(e))
        : [],
      structCount: isSet(object.structCount) ? globalThis.String(object.structCount) : "0",
      structAttributeList: globalThis.Array.isArray(object?.structAttributeList)
        ? object.structAttributeList.map((e: any) => StructAttributeRecord.fromJSON(e))
        : [],
      structDefenderList: globalThis.Array.isArray(object?.structDefenderList)
        ? object.structDefenderList.map((e: any) => StructDefender.fromJSON(e))
        : [],
      structDestructionQueue: globalThis.Array.isArray(object?.structDestructionQueue)
        ? object.structDestructionQueue.map((e: any) => StructDestructionQueueRecord.fromJSON(e))
        : [],
      substationList: globalThis.Array.isArray(object?.substationList)
        ? object.substationList.map((e: any) => Substation.fromJSON(e))
        : [],
      substationCount: isSet(object.substationCount) ? globalThis.String(object.substationCount) : "0",
      permissionList: globalThis.Array.isArray(object?.permissionList)
        ? object.permissionList.map((e: any) => PermissionRecord.fromJSON(e))
        : [],
      guildRankPermissionList: globalThis.Array.isArray(object?.guildRankPermissionList)
        ? object.guildRankPermissionList.map((e: any) => GuildRankPermissionRecord.fromJSON(e))
        : [],
      permissionCleanupQueue: globalThis.Array.isArray(object?.permissionCleanupQueue)
        ? object.permissionCleanupQueue.map((e: any) => globalThis.String(e))
        : [],
      generatorPowerQueue: globalThis.Array.isArray(object?.generatorPowerQueue)
        ? object.generatorPowerQueue.map((e: any) => globalThis.String(e))
        : [],
      stakingUnbondingId: isSet(object.stakingUnbondingId) ? globalThis.String(object.stakingUnbondingId) : "0",
      reactorStakeCapActive: isSet(object.reactorStakeCapActive)
        ? globalThis.Boolean(object.reactorStakeCapActive)
        : false,
      gridList: globalThis.Array.isArray(object?.gridList)
        ? object.gridList.map((e: any) => GridRecord.fromJSON(e))
        : [],
      gridCascadeQueue: globalThis.Array.isArray(object?.gridCascadeQueue)
        ? object.gridCascadeQueue.map((e: any) => globalThis.String(e))
        : [],
      addressList: globalThis.Array.isArray(object?.addressList)
        ? object.addressList.map((e: any) => AddressRecord.fromJSON(e))
        : [],
      addressNonceList: globalThis.Array.isArray(object?.addressNonceList)
        ? object.addressNonceList.map((e: any) => AddressNonceRecord.fromJSON(e))
        : [],
      fleetList: globalThis.Array.isArray(object?.fleetList)
        ? object.fleetList.map((e: any) => Fleet.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GenesisState): unknown {
    const obj: any = {};
    if (message.params !== undefined) {
      obj.params = Params.toJSON(message.params);
    }
    if (message.portId !== "") {
      obj.portId = message.portId;
    }
    if (message.vaultOwnerList?.length) {
      obj.vaultOwnerList = message.vaultOwnerList;
    }
    if (message.allocationList?.length) {
      obj.allocationList = message.allocationList.map((e) => Allocation.toJSON(e));
    }
    if (message.allocationCount !== "0") {
      obj.allocationCount = message.allocationCount;
    }
    if (message.agreementList?.length) {
      obj.agreementList = message.agreementList.map((e) => Agreement.toJSON(e));
    }
    if (message.infusionList?.length) {
      obj.infusionList = message.infusionList.map((e) => Infusion.toJSON(e));
    }
    if (message.infusionDestructionQueue?.length) {
      obj.infusionDestructionQueue = message.infusionDestructionQueue;
    }
    if (message.infusionMaturitySweepQueue?.length) {
      obj.infusionMaturitySweepQueue = message.infusionMaturitySweepQueue;
    }
    if (message.guildList?.length) {
      obj.guildList = message.guildList.map((e) => Guild.toJSON(e));
    }
    if (message.guildCount !== "0") {
      obj.guildCount = message.guildCount;
    }
    if (message.guildMembershipApplicationList?.length) {
      obj.guildMembershipApplicationList = message.guildMembershipApplicationList.map((e) =>
        GuildMembershipApplication.toJSON(e)
      );
    }
    if (message.guildCharterAnchor !== "0") {
      obj.guildCharterAnchor = message.guildCharterAnchor;
    }
    if (message.planetList?.length) {
      obj.planetList = message.planetList.map((e) => Planet.toJSON(e));
    }
    if (message.planetCount !== "0") {
      obj.planetCount = message.planetCount;
    }
    if (message.planetAttributeList?.length) {
      obj.planetAttributeList = message.planetAttributeList.map((e) => PlanetAttributeRecord.toJSON(e));
    }
    if (message.playerList?.length) {
      obj.playerList = message.playerList.map((e) => Player.toJSON(e));
    }
    if (message.playerCount !== "0") {
      obj.playerCount = message.playerCount;
    }
    if (message.providerList?.length) {
      obj.providerList = message.providerList.map((e) => Provider.toJSON(e));
    }
    if (message.providerCount !== "0") {
      obj.providerCount = message.providerCount;
    }
    if (message.providerGuildAccessList?.length) {
      obj.providerGuildAccessList = message.providerGuildAccessList.map((e) => ProviderGuildAccessRecord.toJSON(e));
    }
    if (message.reactorList?.length) {
      obj.reactorList = message.reactorList.map((e) => Reactor.toJSON(e));
    }
    if (message.reactorCount !== "0") {
      obj.reactorCount = message.reactorCount;
    }
    if (message.structList?.length) {
      obj.structList = message.structList.map((e) => Struct.toJSON(e));
    }
    if (message.structCount !== "0") {
      obj.structCount = message.structCount;
    }
    if (message.structAttributeList?.length) {
      obj.structAttributeList = message.structAttributeList.map((e) => StructAttributeRecord.toJSON(e));
    }
    if (message.structDefenderList?.length) {
      obj.structDefenderList = message.structDefenderList.map((e) => StructDefender.toJSON(e));
    }
    if (message.structDestructionQueue?.length) {
      obj.structDestructionQueue = message.structDestructionQueue.map((e) => StructDestructionQueueRecord.toJSON(e));
    }
    if (message.substationList?.length) {
      obj.substationList = message.substationList.map((e) => Substation.toJSON(e));
    }
    if (message.substationCount !== "0") {
      obj.substationCount = message.substationCount;
    }
    if (message.permissionList?.length) {
      obj.permissionList = message.permissionList.map((e) => PermissionRecord.toJSON(e));
    }
    if (message.guildRankPermissionList?.length) {
      obj.guildRankPermissionList = message.guildRankPermissionList.map((e) => GuildRankPermissionRecord.toJSON(e));
    }
    if (message.permissionCleanupQueue?.length) {
      obj.permissionCleanupQueue = message.permissionCleanupQueue;
    }
    if (message.generatorPowerQueue?.length) {
      obj.generatorPowerQueue = message.generatorPowerQueue;
    }
    if (message.stakingUnbondingId !== "0") {
      obj.stakingUnbondingId = message.stakingUnbondingId;
    }
    if (message.reactorStakeCapActive !== false) {
      obj.reactorStakeCapActive = message.reactorStakeCapActive;
    }
    if (message.gridList?.length) {
      obj.gridList = message.gridList.map((e) => GridRecord.toJSON(e));
    }
    if (message.gridCascadeQueue?.length) {
      obj.gridCascadeQueue = message.gridCascadeQueue;
    }
    if (message.addressList?.length) {
      obj.addressList = message.addressList.map((e) => AddressRecord.toJSON(e));
    }
    if (message.addressNonceList?.length) {
      obj.addressNonceList = message.addressNonceList.map((e) => AddressNonceRecord.toJSON(e));
    }
    if (message.fleetList?.length) {
      obj.fleetList = message.fleetList.map((e) => Fleet.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GenesisState>, I>>(base?: I): GenesisState {
    return GenesisState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GenesisState>, I>>(object: I): GenesisState {
    const message = createBaseGenesisState();
    message.params = (object.params !== undefined && object.params !== null)
      ? Params.fromPartial(object.params)
      : undefined;
    message.portId = object.portId ?? "";
    message.vaultOwnerList = object.vaultOwnerList?.map((e) => e) || [];
    message.allocationList = object.allocationList?.map((e) => Allocation.fromPartial(e)) || [];
    message.allocationCount = object.allocationCount ?? "0";
    message.agreementList = object.agreementList?.map((e) => Agreement.fromPartial(e)) || [];
    message.infusionList = object.infusionList?.map((e) => Infusion.fromPartial(e)) || [];
    message.infusionDestructionQueue = object.infusionDestructionQueue?.map((e) => e) || [];
    message.infusionMaturitySweepQueue = object.infusionMaturitySweepQueue?.map((e) => e) || [];
    message.guildList = object.guildList?.map((e) => Guild.fromPartial(e)) || [];
    message.guildCount = object.guildCount ?? "0";
    message.guildMembershipApplicationList =
      object.guildMembershipApplicationList?.map((e) => GuildMembershipApplication.fromPartial(e)) || [];
    message.guildCharterAnchor = object.guildCharterAnchor ?? "0";
    message.planetList = object.planetList?.map((e) => Planet.fromPartial(e)) || [];
    message.planetCount = object.planetCount ?? "0";
    message.planetAttributeList = object.planetAttributeList?.map((e) => PlanetAttributeRecord.fromPartial(e)) || [];
    message.playerList = object.playerList?.map((e) => Player.fromPartial(e)) || [];
    message.playerCount = object.playerCount ?? "0";
    message.providerList = object.providerList?.map((e) => Provider.fromPartial(e)) || [];
    message.providerCount = object.providerCount ?? "0";
    message.providerGuildAccessList =
      object.providerGuildAccessList?.map((e) => ProviderGuildAccessRecord.fromPartial(e)) || [];
    message.reactorList = object.reactorList?.map((e) => Reactor.fromPartial(e)) || [];
    message.reactorCount = object.reactorCount ?? "0";
    message.structList = object.structList?.map((e) => Struct.fromPartial(e)) || [];
    message.structCount = object.structCount ?? "0";
    message.structAttributeList = object.structAttributeList?.map((e) => StructAttributeRecord.fromPartial(e)) || [];
    message.structDefenderList = object.structDefenderList?.map((e) => StructDefender.fromPartial(e)) || [];
    message.structDestructionQueue =
      object.structDestructionQueue?.map((e) => StructDestructionQueueRecord.fromPartial(e)) || [];
    message.substationList = object.substationList?.map((e) => Substation.fromPartial(e)) || [];
    message.substationCount = object.substationCount ?? "0";
    message.permissionList = object.permissionList?.map((e) => PermissionRecord.fromPartial(e)) || [];
    message.guildRankPermissionList =
      object.guildRankPermissionList?.map((e) => GuildRankPermissionRecord.fromPartial(e)) || [];
    message.permissionCleanupQueue = object.permissionCleanupQueue?.map((e) => e) || [];
    message.generatorPowerQueue = object.generatorPowerQueue?.map((e) => e) || [];
    message.stakingUnbondingId = object.stakingUnbondingId ?? "0";
    message.reactorStakeCapActive = object.reactorStakeCapActive ?? false;
    message.gridList = object.gridList?.map((e) => GridRecord.fromPartial(e)) || [];
    message.gridCascadeQueue = object.gridCascadeQueue?.map((e) => e) || [];
    message.addressList = object.addressList?.map((e) => AddressRecord.fromPartial(e)) || [];
    message.addressNonceList = object.addressNonceList?.map((e) => AddressNonceRecord.fromPartial(e)) || [];
    message.fleetList = object.fleetList?.map((e) => Fleet.fromPartial(e)) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
